export default __webpack_public_path__ + "static/media/img-0440-hungary-premium-face.ea1e13b5.png";